import { z } from "zod";

export const baseCategorySchema = z.object({
  name: z
    .string({
      required_error: "Category name is required",
    })
    .min(1, "Category name cannot be empty"),
  description: z.string().optional().nullable(),
  color: z
    .string()
    .regex(/^#[0-9A-Fa-f]{6}$/, "Color must be a valid hex color (e.g., #FF5733)")
    .optional()
    .nullable(),
});

export const createCategorySchema = baseCategorySchema;

export const updateCategorySchema = createCategorySchema.partial().extend({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const getCategorySchema = z.object({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const deleteCategorySchema = z.object({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const listCategoriesSchema = z.object({
  organizationId: z.string().optional().nullable(),
  limit: z.number().positive().optional().nullable().default(50),
  offset: z.number().nonnegative().optional().nullable().default(0),
});

export type ZodCreateCategorySchema = z.infer<typeof createCategorySchema>;
export type ZodUpdateCategorySchema = z.infer<typeof updateCategorySchema>;
export type ZodGetCategorySchema = z.infer<typeof getCategorySchema>;
export type ZodDeleteCategorySchema = z.infer<typeof deleteCategorySchema>;
export type ZodListCategoriesSchema = z.infer<typeof listCategoriesSchema>;

export const categorySchema = baseCategorySchema.extend({
  id: z.string(),
  organizationId: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type CategorySchema = z.infer<typeof categorySchema>;

export const createCategorySchemaDefaultValues: ZodCreateCategorySchema = {
  name: "",
  description: null,
  color: null,
};
